import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=60f052fa&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=ts"
export * from "./InfoBox.vue?vue&type=script&lang=ts"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=60f052fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f052fa",
  null
  
)

export default component.exports